import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Judging panel section for FAQ Page
 */
const JudgingPanelSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="judging-panel-section-component"
    >
      <AccordionV2
        testId="judging-panel"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Who are on the judging panel?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            Each Award has a separate independent judging panel, comprising
            business leaders, professionals and academics.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default JudgingPanelSection;
